import React, { Fragment } from 'react'
import {
  Typography,
  SpacerVertical,
} from '@klarna/bubble-ui'
import LearnMoreOverview from '../Overview'
import LearnMoreTimeline from '../Timeline'
import LearnMoreLegal from '../Legal'
import LoadingSpinner from '../../LoadingSpinner'
import styles from './LearnMoreDefault.css'

export default function LearnMoreDefault({ copy, params }: { copy: any; params: any }) {
  return (
    <Fragment>
      <style>{styles}</style>
      {!copy ? (
        <LoadingSpinner />
      ) : (
        <div className={`country-${params.country}`}>
          <Typography
            id="learn-more-title"
            textToken='text-style/headings/titles/bold/tertiary'
          >
            {copy.title}
          </Typography>
          <SpacerVertical spaceToken='space/100' />
          <Typography textToken='text-style/text/paragraphs/body/regular'>
            {copy.subtitle}
          </Typography>
          <SpacerVertical spaceToken='space/300'/>
          <LearnMoreOverview copy={copy.overview} />
          <SpacerVertical spaceToken='space/400'/>
          <LearnMoreLegal copy={copy.overview_legal} />
          <LearnMoreTimeline
            copy={copy.timeline}
            bespokeId={params.bespokeId}
          />
          <SpacerVertical spaceToken='space/400'/>
          <LearnMoreLegal copy={copy.legal} />
        </div>
      )}
    </Fragment>
  )
}
